import { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';
import StarOutlinedIcon from '@mui/icons-material/StarOutlined';
import { useAppSelector } from "../../store/hooks";
import { DisplayType } from "../../store/features/displaySlice";

export interface FavoriteButtonProps {
    productId?: number,
    initialValue: boolean
}

export const FavoriteButton: React.FC<FavoriteButtonProps> = (props) => {

    return <></>;

    const [favorite, setFavorite] = useState<boolean>(props.initialValue);
    const displayType = useAppSelector((state) => state.display.type)

    const handleFavorite = () => {
        setFavorite(!favorite);
        console.log("Add to favorite: " + props.productId);
        if (favorite) {
            // TODO: Add favorite item ID to user favorites
        } else {
            // TODO: Remove item ID from user favorites
        }
    }

    return (
        <div className={`${favorite && "opacity-100"} group-hover:opacity-100 ${displayType === DisplayType.MOBILE ? "opacity-100" : "opacity-0"} relative cursor-pointer h-[30px] w-[30px] transition-opacity duration-200`} onClick={(e) => {
            e.stopPropagation(); // Prevent parent onClick
            handleFavorite();
        }}>
            {favorite ?

                <Tooltip title="Eemalda meeldivatest" arrow placement='top'>
                    <StarOutlinedIcon className="absolute left-0" style={{ height: "30px", width: "30px", color: "rgb(237, 177, 87)" }} />
                </Tooltip>
                :
                <Tooltip title="Lisa meeldivate nimekirja" arrow placement='top'>
                    <StarBorderOutlinedIcon className='absolute left-0' style={{ height: "30px", width: "30px", color: "rgb(237, 177, 87)" }} />
                </Tooltip>
            }
        </div>)
}